import { useState, useEffect } from 'react'

//Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/css/navigation";
import 'swiper/css/pagination';

import { Box } from '@mui/material';

//Components
import Experts from './Experts';

//Utils
import { CustomFetch } from '../../Utils/CustomFetch';
import { ExpertData } from '../../Data/ExpertsData';

const ExpertItem = ({ team }) => {

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(false)
    CustomFetch(ExpertData)
      .then(res => {
        setData(res.filter(e => e.team === team))
        setLoading(true)
      })
  }, []);

  return (
    <>
      {
        loading ?
          <Box className='experts_swiper'>
            <Swiper
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                400: {
                  slidesPerView: 1,
                },
                600: {
                  slidesPerView: 1,
                },
                700: {
                  slidesPerView: 2,
                },
                1000: {
                  slidesPerView: 3,
                },
              }}
              spaceBetween={40}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              loop={true}
              modules={[Pagination]}
            >
              {data.map((item, i) => (
                <SwiperSlide key={i}>
                  <Experts item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        :
          <>cargando...</>
      }
    </>
  );
};

export default ExpertItem;